import { render, staticRenderFns } from "./Corridas.vue?vue&type=template&id=04414f5a&"
import script from "./Corridas.vue?vue&type=script&lang=js&"
export * from "./Corridas.vue?vue&type=script&lang=js&"
import style0 from "./Corridas.vue?vue&type=style&index=0&id=04414f5a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports